import { Address } from './types';

type AddressDiffToken = { supplied: string | null; suggested: string | null; diff: boolean };
type AddressDiff = {
  address1: AddressDiffToken;
  address2: AddressDiffToken;
  city: AddressDiffToken;
  state: AddressDiffToken;
  zip: AddressDiffToken;
  hasChanges: boolean;
};

export function getValidationDiffs(input: Address, recommended: Address): AddressDiff {
  const diff: AddressDiff = {
    city: {
      supplied: input.city,
      suggested: recommended.city,
      diff: false,
    },
    hasChanges: false,
    state: {
      supplied: input.state,
      suggested: recommended.state,
      diff: false,
    },
    zip: {
      supplied: input.zip,
      suggested: recommended.zip,
      diff: false,
    },
    address1: {
      supplied: input.address1,
      suggested: recommended.address1,
      diff: false,
    },
    address2: {
      supplied: input.address2 ?? '',
      suggested: recommended.address2 ?? '',
      diff: false,
    },
  };

  if (recommended.address1 && input.address1 !== recommended.address1) {
    diff.address1.diff = true;
    diff.hasChanges = true;
  }
  if (recommended.address2 && input.address2 !== recommended.address2) {
    diff.address2.diff = true;
    diff.hasChanges = true;
  }
  if (recommended.city && input.city !== recommended.city) {
    diff.city.diff = true;
    diff.hasChanges = true;
  }
  if (recommended.state && input.state !== recommended.state) {
    diff.state.diff = true;
    diff.hasChanges = true;
  }
  if (recommended.zip && input.zip !== recommended.zip) {
    diff.zip.diff = true;
    diff.hasChanges = true;
  }
  return diff;
}
